/** Display-only formatting of backend-supplied values. No date math. */

export function formatMembershipDate(iso: string | null): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' })
}

export function formatMembershipPrice(cents: number | null, currency: string): string | null {
  if (cents === null) return null
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency }).format(cents / 100)
}
